<template>
  <section>
    <v-layout row>
      <v-data-table
        :headers="headers"
        :items="GetCourseSEO"
        :pagination.sync="pagination"
        select-all
        item-key="Course_Title"
        class="elevation-1"
      >
        <template v-slot:headers="props">
          <tr>
            <th
              v-for="header in props.headers"
              :key="header.text"
              :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
              @click="SortColumn(header.value)"
            >
              <v-icon small>arrow_upward</v-icon>
              {{ header.text }}
            </th>
          </tr>
        </template>
        <template v-slot:items="props">
          <tr :active="props.selected" @click="props.selected = !props.selected">
            <td class="text-xs-center">{{ props.item.Course_Title }}</td>
            <td class="text-xs-center">
              <v-btn color="primary" icon class="btnAction" @click="AddSEODialog(props.item)">
                <v-icon>edit</v-icon>
              </v-btn>
              <v-btn color="primary" icon class="btnAction" @click="DeleteSEO(props.item)">
                <v-icon>delete</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
      <app-add-course-seo ref="SetSEODetails" :dialog="UpdateSEO" @close="CloseDialog"></app-add-course-seo>
    </v-layout>
  </section>
</template>
<script>
import appAddCourseSeo from "../dialogs/AddCourseSEO";

export default {
  components: {
    appAddCourseSeo
  },
  data() {
    return {
      pagination: { sortBy: "Course_Title" },
      headers: [
        { text: "Course Title", value: "Course_Title" },
        { text: "Actions" }
      ],
      UpdateSEO: false
    };
  },
  computed: {
    GetCourseSEO() {
      return this.$store.getters.GetCourseSEO;
    }
  },
  methods: {
    SortColumn(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    AddSEODialog(CourseSEO) {
      this.$refs.SetSEODetails.SetCurrentSEO(CourseSEO);
      this.UpdateSEO = true;
    },
    CloseDialog() {
      this.UpdateSEO = false;
    },
    DeleteSEO(item) {
      let data = item;
      if (confirm("Do you really want to delete?")) {
        this.$store.commit("SetLoading", true);
        this.$http
          .post(
            `${this.$store.getters.GetProductionUrl}/courseseo/deletecourseseo`,
            data
          )
          .then(response => {
            this.$store.commit(
              "DeleteIndividualCourseSEO",
              response["data"]["response"]
            );
            this.$store.commit("SetLoading", false);
          })
          .catch(err => {
            this.$eventHub.$emit("SNACK_BAR", {
              Show: true,
              Text: "Error While Fetching Data",
              Color: "red",
              Close: false
            });
          });
      }
    }
  },
  mounted() {
    this.$store.commit("SetLoading", true);
    
    this.$http
      .post(`${this.$store.getters.GetProductionUrl}/courseseo/getcourseseo`)
      .then(response => {
        this.$store.commit("SetCourseSEO", response["data"]["response"]);
        this.$store.commit("SetLoading", false);
      })
      .catch(err => {
        this.$eventHub.$emit("SNACK_BAR", {
          Show: true,
          Text: "Error While Fetching Data",
          Color: "red",
          Close: false
        });
      });
  }
};
</script>
<style scoped>
.btnAction {
  margin: 4px;
  border: 1px solid #d3d3d37a;
}
</style>


